import { c as _c } from "react/compiler-runtime";
import { LinkExternal01Icon } from '@systemeio/icons';
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { TriggerFormItem } from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-form-item';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum, AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { AutomationRulesTriggersEditType, TriggerFunnelFormSubscribedEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { getFunnelStepUrl } from 'modules/funnels/funnel/utils/get-funnel-step-url';
import { getFunnelUrl } from 'modules/funnels/utils/get-funnel-url';
import React from 'react';
import { FormSelect } from 'shared/components';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface TriggerFunnelFormSubscribedlItemProps extends EditTriggerItemInterface<TriggerFunnelFormSubscribedEditInterface> {}
export const TriggerFunnelFormSubscribedlItem = t0 => {
  const $ = _c(19);
  const {
    trigger,
    idx,
    onDelete,
    setRules,
    errors,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = trigger as AutomationRulesTriggersEditType;
  let t2;
  if ($[0] !== idx || $[1] !== onDelete) {
    t2 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== errors || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== trigger.funnelStep.form || $[9] !== trigger.funnelStep.funnel || $[10] !== trigger.funnelStep.id || $[11] !== trigger.funnelStep.name || $[12] !== trigger.funnelStep.pageContentId || $[13] !== trigger.id) {
    t3 = t4 => {
      const {
        renderTriggerLabel,
        data,
        onOpen
      } = t4;
      return <><FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.form_subscribed)} required={true} label={renderTriggerLabel({
          label: t("dashboard.funnel.title"),
          additionalLabel: trigger.funnelStep.funnel.id ? <LinkWithoutPrefetch href={getFunnelUrl(trigger.funnelStep.funnel.id)} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><LinkExternal01Icon className="text-icon-tertiary transition-base group-focus-visible:text-icon-accent hover:text-icon-link-hover" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_funnel")} value={trigger.funnelStep.funnel.id} data={data.funnelsFormSubscribeData} staticData={getDataFromObj(trigger.funnelStep.funnel)} onChange={data_0 => {
          setRules(prev => ({
            ...prev,
            triggers: prev.triggers.map((el, i) => {
              if (i === idx) {
                return {
                  ...el,
                  funnelStep: {
                    funnel: {
                      id: data_0
                    },
                    id: undefined,
                    form: null,
                    pageContentId: undefined
                  }
                };
              }
              return el;
            })
          }));
        }} error={errors.automationTriggers[trigger.id]?.funnel?.join("")} />{trigger.funnelStep.funnel.id && <FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.form_subscribed_funnel_step)} required={true} label={renderTriggerLabel({
          label: t("dashboard.funnel.funnel_step"),
          additionalLabel: trigger.funnelStep.funnel.id && trigger.funnelStep.id ? <LinkWithoutPrefetch href={getFunnelStepUrl(trigger.funnelStep.funnel.id, trigger.funnelStep.id)} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><LinkExternal01Icon className="text-icon-tertiary transition-base group-focus-visible:text-icon-accent hover:text-icon-link-hover" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_funnel_step")} value={trigger.funnelStep.id} staticData={getDataFromObj({
          id: trigger.funnelStep.id,
          name: trigger.funnelStep.name
        })} data={data.funnelStepsFormSubscribeData} onChange={selectedId => {
          setRules(prev_0 => ({
            ...prev_0,
            triggers: prev_0.triggers.map((el_0, i_0) => {
              if (i_0 === idx) {
                if (el_0.type === AutomationRuleTriggersEnum.form_subscribed) {
                  if (!data.funnelStepsFormSubscribeData) {
                    return el_0;
                  }
                  const selectedStep = data.funnelStepsFormSubscribeData.find(step => step.id === selectedId);
                  return {
                    ...el_0,
                    funnelStep: {
                      ...el_0.funnelStep,
                      id: selectedId,
                      pageContentId: selectedStep?.pageContentId,
                      form: null
                    }
                  };
                }
              }
              return el_0;
            })
          }));
        }} error={errors.automationTriggers[trigger.id]?.funnelStep?.join("")} />}{trigger.funnelStep.id && trigger.funnelStep.pageContentId && <TriggerFormItem pageId={trigger.funnelStep.pageContentId} form={trigger.funnelStep.form} onFormChange={form => {
          setRules(prev_1 => ({
            ...prev_1,
            triggers: prev_1.triggers.map((el_1, i_1) => {
              if (idx === i_1 && el_1.type === AutomationRuleTriggersEnum.form_subscribed) {
                return {
                  ...el_1,
                  funnelStep: {
                    ...el_1.funnelStep,
                    form
                  }
                };
              }
              return el_1;
            })
          }));
        }} errors={errors} onOpen={onOpen} triggerId={trigger.id} />}</>;
    };
    $[3] = errors;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = trigger.funnelStep.form;
    $[9] = trigger.funnelStep.funnel;
    $[10] = trigger.funnelStep.id;
    $[11] = trigger.funnelStep.name;
    $[12] = trigger.funnelStep.pageContentId;
    $[13] = trigger.id;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3) {
    t4 = <EditTriggerWrapper trigger={t1} onDelete={t2}>{t3}</EditTriggerWrapper>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};